import React, { useState } from 'react';
import View from 'src/components/view';
import Element from 'src/components/element';
import utils from 'src/components/utils';

function Informativos() {
  let view = {};
  let [element, setElement] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {} });
  let [index, setIndex] = useState(0);
  let [access, setAccess] = useState(window.access ? window.access : {});

  crud.refresh = function () {
    setIndex(index + 1);
    setCrud(crud);
  };

  crud.setTipo = function (_el, args) {
    crud.changed.tipoInformativo = args.data.constante;
    crud.data.tipoInformativo = args.data.constante;
    crud.tipoInformativo = args.data.constante;

    if (window.informativo) {
      window.informativo.search();
    }
  };

  view.onCheck = function (a) {
    access = a;

    element = {
      layout: 'list',
      header: false,
      search: true,
      filter: true,
      name: 'itens',
      field: 'itens',
      type: 'list',
      styleClass: 'ui-informativos',
      border: '5px solid var(--theme)',
      space: 12,
      size: 20,
      visible: true,
      required: false,
      label: utils.lng('informativo_download', 'Informativos e Downloads'),
      controls: false,
      entity: 'Informativo',
      groupValue: 'tipo_constante',
      groupLabel: 'tipo_descricao',
      groupType: 'select',
      columns: {
        icone: {
          type: 'icon',
          value: 'fa fa-file-pdf',
          columnStyleClass: 'row-card',
          columnStyle: {
            background: 'transparent',
            color: 'rgb(15, 15, 38)',
            fontSize: '20px',
            width: '80px',
            textAlign: 'center',
            margin: 'auto',
          },
        },
        detalhes: {
          elements: {
            titulo: {
              value: '<b>' + utils.lng('Documento:', 'Documento:') + '</b> ${data.titulo}',
              type: 'span',
              styleClass: 'ui-informativo-titulo-clamp',
            },
            tipo_descricao: {
              value: '<b>' + utils.lng('Categoria', 'Categoria') + ':</b> ${data.tipo_descricao}',
              type: 'span',
            },
            data_informativo: {
              value: '<b>' + utils.lng('Data', 'Data') + ':</b> ${data.data_informativo}',
              type: 'span',
            },
          },
        },
        link_conteudo: {
          columnStyleClass: 'WhiteColor',
          columnStyle: {
            display: 'block',
            background: '#013A7B',
            fontSize: '1rem',
            width: '45px',
            height: '45px',
            margin: '21px',
            textAlign: 'center',
          },
          link: 'icon',
          type: 'link',
          preview: false,
          target: '_blank',
          icon: 'fa fa-download',
        },
      },
      list: {
        url: 'listarInformativos',
      },
      // widgetVar: 'informativo',
      // rowStyleClass: "ui-border-${@this.ativo ? 'green' : 'red'} ui-border-left",
      // groupValue: 'tipo_constante',
      // groupLabel: 'tipo_descricao',
    };

    if (access.CADASTRAR) {
      element.add = {
        redirect: 'crud/Informativo/0',
      };
      element.click = {
        redirect: 'crud/Informativo/{id}',
      };
    }
    setElement(element);
    setAccess(a);
    setIndex(index + 1);
  };

  return (
    <View name="informativos" view={view}>
      <Element id={'i' + index} value={element} crud={crud} data={crud.data} view={view}></Element>
    </View>
  );
}

export default Informativos;
